import { RecursiveObject } from '@chakra-ui/react';

// TODO:
export const borders: RecursiveObject = {};
